export default "__VITE_ASSET__07093ad8__"